module.exports = __webpack_public_path__ + "static/img/5.4f9047b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/5.jpg
// module id = CkN/
// module chunks = 11